import Vue from 'vue';
import { createDecorator } from 'vue-class-component';
import Vuex from 'vuex';

Vue.use(Vuex);

export enum Getters {
  ID_TOKEN = 'ID_TOKEN',
  PROFILE = 'PROFILE',
  WORKER = 'WORKER',
}

export enum Mutations {
  LOGIN = 'LOGIN',
  SET_WORKER = 'SET_WORKER',
}

export enum Actions {
}

export const store = new Vuex.Store({
  state: {
    auth: {
      idToken: null,
      profile: null,
    },
    worker: null,
  },
  getters: {
    [Getters.ID_TOKEN]: (state) => {
      return state.auth.idToken;
    },
    [Getters.PROFILE]: (state) => {
      return state.auth.profile;
    },
    [Getters.WORKER]: (state) => {
      return state.worker;
    },
  },
  mutations: {
    [Mutations.LOGIN]: (state, payload) => {
      state.auth.idToken = payload.idToken;
      state.auth.profile = payload.idTokenPayload;
    },
    [Mutations.SET_WORKER]: (state, payload) => {
      state.worker = payload;
    },
  },
  actions: {},
});

export const Getter = (type: string) => {
  return createDecorator((options, key) => {
    if (!options.computed) {
      options.computed = {};
    }

    options.computed[key] = function() {
      return (this.$store as any).getters[type];
    };
  });
};


